export default function useSystemLayout () {
  return {
    getIllustrationsPath: () => { return '/' }
  }
}